import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { Slownik } from '../../../../../../shared/models/slownik';

export class AnnouncementRecipientDialogValidators {
  static minLength(
    minLength = 3,
  ): (control: AbstractControl) => ValidationErrors | null {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (value == null || value === '') {
        return null;
      }

      if (typeof value !== 'string') {
        return null;
      }

      return value.trim().length >= minLength
        ? null
        : { recipientSearchMinLength: true };
    };
  }

  static searchCriteria(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!(control instanceof FormGroup)) {
        return null;
      }

      const pesel = (control.get('pesel')?.value as string | null)?.trim();
      const firstName = (
        control.get('firstName')?.value as string | null
      )?.trim();
      const lastName = (
        control.get('lastName')?.value as string | null
      )?.trim();
      const documentNumber = (
        control.get('documentNumber')?.value as string | null
      )?.trim();
      const birthDate = control.get('birthDate')?.value as Date | null;
      const email = (control.get('email')?.value as string | null)?.trim();
      const city = control.get('city')?.value as Slownik | null;

      const hasValidPesel = !!pesel && !control.get('pesel')?.invalid;

      const hasNamePair =
        !!firstName &&
        !!lastName &&
        !control.get('firstName')?.invalid &&
        !control.get('lastName')?.invalid;

      const hasAdditionalCriteria =
        (!!documentNumber && !control.get('documentNumber')?.invalid) ||
        !!birthDate ||
        (!!email && !control.get('email')?.invalid) ||
        !!city;

      return hasValidPesel || (hasNamePair && hasAdditionalCriteria)
        ? null
        : { invalidRecipientSearchCriteria: true };
    };
  }
}
